import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { PlaneTakeoff, Settings, Zap, Package, Cpu, Truck, Wrench, Users, ClipboardList } from 'lucide-react';
export function TransportationServices() {
  const services = [{
    icon: PlaneTakeoff,
    title: 'Aircraft Engines',
    description: 'Safe and secure transport of turbine and piston engines nationwide.'
  }, {
    icon: Settings,
    title: 'Landing Gear',
    description: 'Specialized handling and delivery of landing gear assemblies.'
  }, {
    icon: Zap,
    title: 'APUs & Components',
    description: 'Auxiliary power units and critical aircraft components, delivered on time.'
  }, {
    icon: Package,
    title: 'Aviation Parts & Components',
    description: 'Full chain-of-custody transport for all aviation parts and hardware.'
  }, {
    icon: Cpu,
    title: 'Avionics Equipment',
    description: 'Sensitive avionics handled with expert care and proper packaging.'
  }, {
    icon: Truck,
    title: 'Airframes & Specialized Cargo',
    description: 'Oversized and specialized cargo with flatbeds, step decks and conestogas.'
  }];
  return <section id="services" className="py-24 bg-navy-light relative border-b border-white/5" data-id="element-379" data-mp="2vu7mj9h0mjow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-380" data-mp="1y6pek0v6hlly">
        <div className="text-center mb-16" data-id="element-381" data-mp="1y4crxaeh6n2k">
          <span className="text-gold text-sm font-bold tracking-widest uppercase mb-3 block" data-id="element-382" data-mp="234r0ctjznz14">
            What We Transport
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4 uppercase" data-id="element-383" data-mp="283c0yu35kkq3">
            Specialized Aviation Cargo Transport
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-384" data-mp="1fgr9ltmog8mj">
            Safe, secure and time-critical delivery of aviation components
            across the United States.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-385" data-mp="1cdbegylu5qdy">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-navy rounded-2xl p-8 border border-white/5 hover:border-gold/30 transition-all group relative overflow-hidden flex flex-col h-full" data-id="element-386" data-mp="17f07cvmxdtzf" data-mpi={index}>
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full -mr-16 -mt-16 transition-transform group-hover:scale-110 pointer-events-none" data-id="element-387" data-mp="ydaedldeamzj"></div>

              <div className="w-14 h-14 rounded-full bg-navy-light border border-gold/20 flex items-center justify-center mb-6 relative z-10 group-hover:shadow-gold-glow transition-all shrink-0" data-id="element-388" data-mp="29sz0kaitrhza">
                <service.icon className="w-7 h-7 text-gold" data-id="element-389" data-mp="2mde7qfzulu4q" />
              </div>

              <h3 className="text-xl font-heading font-bold text-white mb-3 uppercase tracking-wide relative z-10" data-id="element-390" data-mp="28dd5aw3xqen5">
                {service.title}
              </h3>
              <p className="text-slate-300 leading-relaxed relative z-10 text-base" data-id="element-391" data-mp="303rck9hg0spu">
                {service.description}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-24 mb-16" data-id="element-392" data-mp="354otyjumpiqa">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-393" data-mp="2rc8yq57yyozx">
            <span className="text-gold text-sm font-bold tracking-widest uppercase mb-3 block" data-id="element-394" data-mp="3nudhvt02byw5">
              Aviation Services
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4 uppercase" data-id="element-395" data-mp="202nwjvvuuoyq">
              We Have The Know-How You Need.
            </h2>
            <p className="text-xl text-gold italic font-medium mb-6 tracking-wide max-w-3xl mx-auto" data-id="element-396" data-mp="1q7m8l3dbfsxq">
              Our goal is to reduce downtime and get your aircraft back into
              flight.
            </p>
            <p className="text-base md:text-lg text-slate-200 leading-relaxed max-w-3xl mx-auto" data-id="element-397" data-mp="2iuqct64l438g">
              JetForce Aerospace provides specialized aviation transportation
              and logistics solutions to industry-leading airlines, MROs, repair
              stations, OEMs and operators. Our team of FAA certified A&P
              professionals operates 24/7 with specialized equipment designed to
              handle aviation components — from fragile avionics to heavy engine
              parts — on Commercial, Private and Military aircraft, including
              time-critical AOG circumstances.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10" data-id="element-398" data-mp="oaybp8gf4xf0">
            {[{
            icon: PlaneTakeoff,
            title: 'Air Cargo Transportation',
            description: 'Expedited air cargo transportation ensuring timely delivery of crucial aviation components, equipment and supplies to support the fast-paced demands of the aerospace industry.'
          }, {
            icon: Wrench,
            title: 'Specialized Equipment',
            description: 'Our fleet is equipped to handle a wide range of cargo, including oversized and delicate items — from aircraft engines to satellite components — transported with full safety compliance.'
          }, {
            icon: Users,
            title: 'Trained & Experienced',
            description: 'Our team is extensively trained in aerospace cargo handling, FAA and TSA regulations, safety protocols, and the technical requirements of aircraft component shipping.'
          }, {
            icon: ClipboardList,
            title: 'Customized Solutions',
            description: 'We build customized logistics solutions that meet each client\u2019s unique requirements, with dedicated support available to ensure a seamless experience from start to finish.'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-navy rounded-2xl p-7 border border-gold/20 hover:border-gold/50 transition-all group relative overflow-hidden flex flex-col h-full" data-id="element-399" data-mp="imghz36bid0h" data-mpi={index}>
                <div className="w-14 h-14 rounded-full bg-navy-light border border-gold/20 flex items-center justify-center mb-5 group-hover:shadow-gold-glow transition-all shrink-0" data-id="element-400" data-mp="l7nzblzf721x">
                  <item.icon className="w-7 h-7 text-gold" data-id="element-401" data-mp="c5ofklx0tjva" />
                </div>
                <h3 className="text-lg font-heading font-bold text-white mb-3 uppercase tracking-wide" data-id="element-402" data-mp="h7dq80gbzviu">
                  {item.title}
                </h3>
                <p className="text-slate-200 leading-relaxed text-sm" data-id="element-403" data-mp="786gdn8t2j0h">
                  {item.description}
                </p>
              </motion.div>)}
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4" data-id="element-404" data-mp="1wl035wv6jko3">
            {['FAA Certified Personnel', '24/7 Operations', 'AOG Specialists', 'Regulatory Compliant'].map((badge, idx) => <div key={idx} className="border border-gold/40 bg-navy-light/60 rounded-full px-5 py-2 text-sm font-medium text-gold uppercase tracking-wider" data-id="element-405" data-mp="ke9dvdfzfw44" data-mpi={idx}>
                {badge}
              </div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy border border-gold/20 rounded-xl p-6 text-center mb-12" data-id="element-406" data-mp="5pmm2c965bw0">
          <p className="text-gold font-medium text-sm md:text-base tracking-wide" data-id="element-407" data-mp="3nwklu307kudp">
            <span className="text-white font-bold mr-2" data-id="element-408" data-mp="1r1en97uju004">
              Specialized Equipment:
            </span>
            Flatbeds · Step Decks · Conestogas · Hot Shot · Expedited · Oversize
            Permits
          </p>
        </motion.div>

        <div className="text-center" data-id="element-409" data-mp="1yl741nv2x4oy">
          <a href="#contact" className="inline-block bg-gold hover:bg-gold-light text-navy font-bold py-4 px-10 rounded-full transition-all shadow-gold-glow hover:shadow-gold-glow-lg transform hover:-translate-y-1 text-lg" data-id="element-410" data-mp="1yk4ebj9ht8am">
            Request a Transport Quote
          </a>
        </div>
      </div>
    </section>;
}